import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { CENTRALIZED_BUTTON_CONVERTER_TOKEN, CentralizedButtonConverter } from './centralized-button.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        centralizedButtonFeature: {
          module: () => import('./centralized-button.module').then((m) => m.CentralizedButtonModule),
          cmsComponents: ['centralized_button']
        },
      }
    }),
    {
      provide: CENTRALIZED_BUTTON_CONVERTER_TOKEN,
      useExisting: CentralizedButtonConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        centralized_button: CENTRALIZED_BUTTON_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class CentralizedButtonFeatureModule {}
